import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "edit-group-modal-content__main-content main-content" }
const _hoisted_2 = { class: "main-content__container" }
const _hoisted_3 = { class: "main-content__title" }

import { i18n } from '@/i18n';
import { computed, ref, watch } from 'vue';
import GroupListSelectInput from '../GroupListSelectInput.vue';
import InfoModal from '@/corePagesModule/components/InfoModal.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'EditGroupModal',
  props: {
    modalState: { type: Boolean },
    selectInputIndex: {}
  },
  emits: ["close", "apply"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emits = __emit;

//変数
const t = i18n.t;

const selectedGroupId = ref<string>();
const selectedGroupName = ref<string>();

watch(
  () => props.modalState,
  (newVal) => {
    if (newVal) {
      selectedGroupId.value = undefined;
      selectedGroupName.value = undefined;
    }
  }
);

const isDisabledApplyButton = computed((): boolean => selectedGroupId.value === undefined || selectedGroupId.value === '');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(InfoModal, {
    "modal-state": _ctx.modalState,
    "back-button-label": _unref(t)('キャンセル'),
    "next-button-label": _unref(t)('決定'),
    "modal-width": 764,
    "is-disabled-next-button": isDisabledApplyButton.value,
    onOnBack: _cache[2] || (_cache[2] = ($event: any) => (emits('close'))),
    onOnNext: _cache[3] || (_cache[3] = ($event: any) => (emits('apply', selectedGroupId.value ?? '', selectedGroupName.value ?? '')))
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)('編集するグループを選択')), 1)
    ]),
    description: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)('選択したグループの取引を編集できます。')), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('グループ名')), 1),
          _createVNode(GroupListSelectInput, {
            class: "main-content__select-input",
            "select-input-index": _ctx.selectInputIndex,
            "store-tag": 'editGroup',
            onSelectedGroup: _cache[0] || (_cache[0] = (groupId) => (selectedGroupId.value = groupId)),
            onSelectedGroupName: _cache[1] || (_cache[1] = (groupName) => (selectedGroupName.value = groupName))
          }, null, 8, ["select-input-index"])
        ])
      ])
    ], undefined, true),
    _: 1
  }, 8, ["modal-state", "back-button-label", "next-button-label", "is-disabled-next-button"]))
}
}

})